module.exports = __webpack_public_path__ + "static/media/5.83c7a8f9.jpg";